// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface String {
    getHash(): string;
}

String.prototype.getHash = function(): string {
    const source = this as string;

    let hash = 0, i, chr;

    if (source.length === 0) {
        return hash.toString();
    }
    for (i = 0; i < source.length; i++) {
        chr = source.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    return hash.toString();
};
